
<div class="spinner-block">
  <mat-spinner></mat-spinner>
</div>
